import React, { Component } from 'react';
import { debounce } from 'lodash/fp';
import { Icon, Spinner } from 'ui';
import FileStackImage from 'misc/filestack_image';

class ImageCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
    this.image = new FileStackImage({
      policy: props.image.policy,
      signature: props.image.signature,
      handle: props.image.handle,
      transform: {
        resize: {
          width: 400,
          height: 400,
        },
      },
    });
    this.src = this.image.url;
    this.handleImageClick = this.handleImageClick.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.image.handle !== this.props.image.handle) {
      this.src = this.image.updateParams(nextProps.image).url;
    }
  }

  componentDidMount() {
    const image = new Image();
    image.src = this.src;
    image.onload = () => this.setState({ loading: false });
  }

  static defaultProps = {
    onClick: () => {},
  };

  handleImageClick() {
    this.props.onClick(this.props.image);
  }

  render() {
    const debouncedImageClick = debounce(300, this.handleImageClick);

    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <div className="Image" onClick={debouncedImageClick}>
        <div className="Image-imageContainer">
          {this.state.loading && <Spinner />}
          {!this.state.loading && (
            <img
              className="Animated Animated--fadeIn"
              src={this.src}
              alt={this.props.file_name}
            />
          )}
        </div>
        <div className="Image-info fz-base">
          <Icon name="lesson" className="c-gray mr-4" />
          {this.props.image.times_used}
        </div>
      </div>
    );
  }
}

export default ImageCard;
